import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Container } from "reactstrap";
import { useAuth0 } from "@auth0/auth0-react";

import Home from "./views/Home";
import MobileSSOComponent from "./views/MobileSSO";
import MobileSSOUnavailable from "./views/MobileSSOUnavailable";
import { isWebViewContext } from "./views/webViewHelper";

import "./App.css";

const App = () => {
  const { error } = useAuth0();

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  return (
    <BrowserRouter>
      <div id="app" className="d-flex flex-column h-100">
        <Container className="flex-grow-1 mt-5">
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route
              path="/mobilesso"
              element={
                isWebViewContext() ? (
                  <MobileSSOComponent />
                ) : (
                  <MobileSSOUnavailable />
                )
              }
            />
          </Routes>
        </Container>
      </div>
    </BrowserRouter>
  );
};
export default App;
